export default __webpack_public_path__ + "static/media/GBprojet.e39bbbbc.png";